import { Link } from "react-router-dom";
import { getFeaturedArticles } from "@/mocks/articles";

export default function HeroSection() {
  const featured = getFeaturedArticles();
  const mainArticle = featured[0];
  const subArticles = featured.slice(1, 3);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20theatrical%20stage%20with%20red%20velvet%20curtains%20partially%20drawn%2C%20a%20single%20spotlight%20illuminating%20the%20center%2C%20mysterious%20atmosphere%20with%20deep%20shadows%2C%20cinematic%20lighting%2C%20the%20curtains%20have%20a%20rich%20burgundy%20and%20crimson%20tone%2C%20elegant%20theatrical%20aesthetic%2C%20dark%20background%20with%20subtle%20gold%20accents%2C%20premium%20editorial%20style&width=1600&height=900&seq=hero-bg-main-2026&orientation=landscape"
          alt="每日黑料 - 网红塌房现场直击，每日黑料大赛入口"
          title="每日黑料 - 每日黑料大赛入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-12">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
          <div className="flex-1 flex flex-col justify-center">
            <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-sm font-medium rounded-full mb-6 w-fit whitespace-nowrap backdrop-blur-sm">
              <i className="ri-flashlight-line w-4 h-4 flex items-center justify-center inline mr-1.5"></i>
              每日黑料大赛 入口
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-white leading-tight mb-4">
              {mainArticle ? mainArticle.title : "每日黑料吃瓜网最新地址"}
            </h1>
            <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mb-8">
              {mainArticle ? mainArticle.excerpt : "每日黑料网✨聚焦每日黑料大赛入口、每日黑料吃瓜网最新地址，黑料每日爆料与网红塌房现场直击，每日更新吃瓜内容。"}
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              {mainArticle && (
                <Link
                  to={`/article/${mainArticle.id}`}
                  className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-sm"
                >
                  阅读全文
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center inline ml-1.5"></i>
                </Link>
              )}
              <Link
                to="/category/meiri-dasai"
                className="text-sm text-white/80 hover:text-white transition-colors underline underline-offset-4 whitespace-nowrap cursor-pointer"
              >
                每日黑料大赛入口 →
              </Link>
            </div>
          </div>

          <div className="lg:w-[380px] flex flex-col gap-4">
            {subArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="flex gap-4 p-4 rounded-xl bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all cursor-pointer group border border-white/10"
              >
                <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    title={`每日黑料 - ${article.title}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs text-primary-300 font-medium whitespace-nowrap">
                    {index === 0 ? "最新爆料" : "热门吃瓜"}
                  </span>
                  <h3 className="text-sm text-white font-medium line-clamp-2 leading-snug mt-1 group-hover:text-primary-300 transition-colors">
                    {article.title}
                  </h3>
                  <span className="text-xs text-white/50 mt-1.5 block whitespace-nowrap">
                    {article.viewCount >= 10000 ? `${(article.viewCount / 10000).toFixed(1)}万阅读` : `${article.viewCount}阅读`}
                  </span>
                </div>
              </Link>
            ))}
            {subArticles.length === 0 && (
              <div className="p-6 rounded-xl bg-white/10 backdrop-blur-sm text-center">
                <p className="text-white/60 text-sm">加载中...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}